module.exports = __webpack_public_path__ + "img/map-5-f@2x.3e07dfbc.png";